import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../state";
import visa from "../../assets/payment/visa.png";
import mastercard from "../../assets/payment/mastercard.svg";
import iyzicoTr from "../../assets/payment/iyzico-ile-ode.svg";
import iyzicoEn from "../../assets/payment/pay-with-iyzico.svg";
import styles from "./PaymentTrustBadges.module.css";

interface IPaymentTrustBadgesProps {
  /** "footer" = muted row for the site footer; "inline" = larger row for pricing/checkout. */
  variant?: "footer" | "inline";
  className?: string;
}

/**
 * Visa + Mastercard + "Pay with iyzico" trust badges. Required for İyzico merchant activation
 * (their website-criteria checklist) and reassures users at checkout. The iyzico mark is locale-aware
 * ("iyzico ile öde" in TR, "Pay with iyzico" in EN).
 */
const PaymentTrustBadges: React.FC<IPaymentTrustBadgesProps> = ({ variant = "footer", className }) => {
  const languageData = useSelector((state: State) => state.languageReducer);
  const isEnglish = languageData?.appLanguage === "en";
  const t = languageData?.data?.paymentBadges;
  const iyzicoLogo = isEnglish ? iyzicoEn : iyzicoTr;

  return (
    <div
      className={`${styles.badges} ${variant === "inline" ? styles.inline : styles.footer} ${className ?? ""}`}
      role="group"
      aria-label={t?.ariaLabel ?? "Accepted payment methods"}
    >
      {t?.securedBy && <span className={styles.label}>{t.securedBy}</span>}
      <img src={visa} alt="Visa" className={styles.card} loading="lazy" />
      <img src={mastercard} alt="Mastercard" className={styles.card} loading="lazy" />
      <img src={iyzicoLogo} alt={t?.iyzicoAlt ?? "Pay with iyzico"} className={styles.iyzico} loading="lazy" />
    </div>
  );
};

export default PaymentTrustBadges;
